module.exports = __webpack_public_path__ + "img/config_rank.d5808f9d.png";